import { ChargeLevel } from './chargeLevels';
import { ChargeType } from './chargeType';

export default class Charge {
  constructor(public requestNbr: number,
    public offenseNbr: number,
    public chargeNbr: number,
    public countNbr: number,
    public chargeLevel: ChargeLevel,
    public charge: string,
    public disposition: string,
    public chargeStatute: string,
    public chargeProbation: string,
    public chargeFines: string,
    public chargeCourtCosts: string,
    public chargeJailTime: string,
    public chargePrisonTime: string,
    public chargeSuspensionTime: string,
    public chargeNextCourtDate: Date,
    public chargeOffenseDate: Date,
    public noOffenseDateReason: string,
    public chargeFileDate: Date,
    public noFileDateReason: string,
    public chargeArrestDate: Date,
    public noArrestDateReason: string,
    public chargeDispDate: Date,
    public noDispDateReason: string,
    public chargeOtherSentenceNotes: string,
    public chargeCd: ChargeType,
    ) {

      if (this.chargeNextCourtDate !== null) {
        this.chargeNextCourtDate.setHours(0, 0, 0, 0);
      }

      if (this.chargeOffenseDate !==  null) {
        this.chargeOffenseDate.setHours(0, 0, 0, 0);
      }

      if (this.chargeFileDate !==  null) {
        this.chargeFileDate.setHours(0, 0, 0, 0);
      }

      if (this.chargeArrestDate !==  null) {
        this.chargeArrestDate.setHours(0, 0, 0, 0);
      }

      if (this.chargeDispDate !== null) {
        this.chargeDispDate.setHours(0, 0, 0, 0);
      }
    }

    get offenseNumber(): number {
      return this.offenseNbr;
    }

    get chargeNumber(): number {
      return this.chargeNbr;
    }

    get count(): number {
      return this.countNbr;
    }

    set count(count: number) {
      this.countNbr = count;
    }

    get offense(): string {
      return this.charge;
    }

    set offense(offense: string) {
      this.charge = offense;
    }

    get probation(): string {
      return this.chargeProbation;
    }

    set probation(probation: string) {
      this.chargeProbation = probation;
    }

    get fines(): string {
      return this.chargeFines;
    }

    set fines(fines: string) {
      this.chargeFines = fines;
    }

    get courtCost(): string {
      return this.chargeCourtCosts;
    }

    set courtCost(courtCost: string) {
      this.chargeCourtCosts = courtCost;
    }

    get jailTime(): string {
      return this.chargeJailTime;
    }

    set jailTime(jailTime: string) {
      this.chargeJailTime = jailTime;
    }

    get prisonTime(): string {
      return this.chargePrisonTime;
    }

    set prisonTime(prisonTime: string) {
      this.chargePrisonTime = prisonTime;
    }

    get suspensionTime(): string {
      return this.chargeSuspensionTime;
    }

    set suspensionTime(suspensionTime: string) {
      this.chargeSuspensionTime = suspensionTime;
    }

    get nextCourtDate(): Date {
      return this.chargeNextCourtDate;
    }

    set nextCourtDate(nextCourtDate: Date) {
      if (nextCourtDate !== null) {
        nextCourtDate.setHours(0, 0, 0, 0);
      }

      this.chargeNextCourtDate = nextCourtDate;
    }

    get offenseDate(): Date {
      return this.chargeOffenseDate;
    }

    set offenseDate(offenseDate: Date) {
      if (offenseDate !==  null) {
        offenseDate.setHours(0, 0, 0, 0);
      }

      this.chargeOffenseDate = offenseDate;
    }

    get fileDate(): Date {
      return this.chargeFileDate;
    }

    set fileDate(fileDate: Date) {
      if (fileDate !==  null) {
        fileDate.setHours(0, 0, 0, 0);
      }

      this.chargeFileDate = fileDate;
    }

    get arrestDate(): Date {
      return this.chargeArrestDate;
    }

    set arrestDate(arrestDate: Date) {
      if (arrestDate !==  null) {
        arrestDate.setHours(0, 0, 0, 0);
      }

      this.chargeArrestDate = arrestDate;
    }

    get dispositionDate(): Date {
      return this.chargeDispDate;
    }

    set dispositionDate(dispositionDate: Date) {
      if (dispositionDate !== null) {
        dispositionDate.setHours(0, 0, 0, 0);
      }

      this.chargeDispDate = dispositionDate;
    }

    get noDispositionReason(): string {
      return this.noDispDateReason;
    }

    set noDispositionReason(noDispositionReason: string) {
      this.noDispDateReason = noDispositionReason;
    }

    get otherSentenceNotes(): string {
      return this.chargeOtherSentenceNotes;
    }

    set otherSentenceNotes(otherSentenceNotes: string) {
      this.chargeOtherSentenceNotes = otherSentenceNotes;
    }

    get chargeType(): ChargeType {
      return this.chargeCd as ChargeType;
    }

    set chargeType(chargeType: ChargeType) {
      this.chargeCd = chargeType;
    }

    static createCharge(requestNumber: number,
      offenseNumber: number,
      count: number,
      chargeLevel: ChargeLevel,
      offense: string,
      disposition: string,
      chargeStatute: string,
      probation: string,
      fines: string,
      courtCosts: string,
      jailTime: string,
      prisonTime: string,
      suspensionTime: string,
      nextCourtDate: Date,
      offenseDate: Date,
      noOffenseDateReason: string,
      fileDate: Date,
      noFileDateReason: string,
      arrestDate: Date,
      noArrestDateReason: string,
      dispositionDate: Date,
      noDispositionReason: string,
      otherSentenceNotes: string,
      chargeType: ChargeType): Charge {
      return new Charge(requestNumber, offenseNumber, null, count, chargeLevel,
        offense, disposition, chargeStatute, probation,
        fines, courtCosts, jailTime, prisonTime, suspensionTime,
        nextCourtDate, offenseDate, noOffenseDateReason, fileDate,
        noFileDateReason, arrestDate, noArrestDateReason,
        dispositionDate, noDispositionReason, otherSentenceNotes, chargeType);
    }

    static createFromRequest(charges: any): Charge[] {
      if (charges == null) {
        return null;
      }

      const internalCharges = new Array<Charge>();
      for (const chargeBackup of charges) {
        internalCharges.push(new Charge(chargeBackup.requestNbr,
          chargeBackup.offenseNbr,
          chargeBackup.chargeNbr,
          chargeBackup.countNbr,
          chargeBackup.chargeLevel,
          chargeBackup.charge,
          chargeBackup.disposition,
          chargeBackup.chargeStatute,
          chargeBackup.chargeProbation,
          chargeBackup.chargeFines,
          chargeBackup.chargeCourtCosts,
          chargeBackup.chargeJailTime,
          chargeBackup.chargePrisonTime,
          chargeBackup.chargeSuspensionTime,
          chargeBackup.chargeNextCourtDate === null ? null : new Date(chargeBackup.chargeNextCourtDate),
          chargeBackup.chargeOffenseDate === null ? null : new Date(chargeBackup.chargeOffenseDate),
          chargeBackup.noOffenseDateReason,
          chargeBackup.chargeFileDate === null ? null : new Date(chargeBackup.chargeFileDate),
          chargeBackup.noFileDateReason,
          chargeBackup.chargeArrestDate === null ? null : new Date(chargeBackup.chargeArrestDate),
          chargeBackup.noArrestDateReason,
          chargeBackup.chargeDispDate === null ? null : new Date(chargeBackup.chargeDispDate),
          chargeBackup.noDispDateReason,
          chargeBackup.chargeOtherSentenceNotes,
          chargeBackup.chargeCd));
      }

      return internalCharges;
    }
}



// WEBPACK FOOTER //
// ./src/models/charge.ts